import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/hocs/withValidUrl';
import { NoSidebarLayout } from '@public/components/Layouts/NoSidebarLayout';
import { PageWrapper } from '@public/components/Layouts/PageWrapper';
import { LoginPage as Login } from '@public/components/User/Auth/Pages/Login';
import type { GetServerSideProps } from 'next';

const LoginPage = (props: IGenericPageProps) => {
  const canonicalURL = `https://www.on3.com/login/`;

  return (
    <PageWrapper
      {...props}
      alternateBackground={true}
      canonical={canonicalURL}
      hideAds
      title="Login to your account | On3.com"
    >
      <NoSidebarLayout>
        <Login />
      </NoSidebarLayout>
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps<IGenericPageProps> = async (
  ctx,
) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  return { props: { pageType: 'user', siteData, userData } };
};

export default withValidUrl(LoginPage);
